"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PageTypeEnum", {
  enumerable: true,
  get: function get() {
    return _PageType.default;
  }
});
var _PageType = _interopRequireDefault(require("./PageType"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }